import { createVanIconComponent } from "./van"

const UmbrellaCircle = createVanIconComponent("umbrella-circle")
export default UmbrellaCircle
